import { ContatoLogCategoria, ContatoLogEvento } from '../generated/backend-enums.js';
export { ContatoLogCategoria, ContatoLogEvento };
export const ContatoLogEventoMap = {
    [ContatoLogEvento.CRIADO]: 'Cadastrado',
    [ContatoLogEvento.ALTERADO]: 'Dados atualizados',
    [ContatoLogEvento.SECAO_CONFIRMADA]: 'Dados confirmados',
    [ContatoLogEvento.MUDOU_DE_EMPRESA]: 'Mudou de empresa',
    [ContatoLogEvento.CLIENTE_CORRIGIDO]: 'Cliente corrigido',
    [ContatoLogEvento.CARGO_ALTERADO]: 'Mudou de cargo',
    [ContatoLogEvento.RESPONSAVEL_ALTERADO]: 'Mudou de responsável',
    [ContatoLogEvento.RESPONSAVEIS_ALTERADOS]: 'Mudou os responsáveis',
    [ContatoLogEvento.NAO_CONTATAR_MARCADO]: 'Marcado como "não contatar"',
    [ContatoLogEvento.NAO_CONTATAR_DESMARCADO]: 'Desmarcado como "não contatar"',
    [ContatoLogEvento.INATIVADO]: 'Inativado',
    [ContatoLogEvento.REATIVADO]: 'Reativado',
    [ContatoLogEvento.ANONIMIZADO]: 'Dados eliminados a pedido',
    [ContatoLogEvento.DADO_REVELADO]: 'Dado pessoal revelado',
    [ContatoLogEvento.DADO_EXPORTADO]: 'Dado pessoal incluído em relatório',
    [ContatoLogEvento.ABSORVEU]: 'Cadastro absorvido',
    [ContatoLogEvento.MESCLADO]: 'Cadastro mesclado',
};
export const ContatoLogCategoriaMap = {
    [ContatoLogCategoria.ALTERACAO]: 'Alterações',
    [ContatoLogCategoria.ACESSO]: 'Acessos a dado pessoal',
};
